import { Component } from "react";
import CreateSiteForm, { SiteType } from "../models/CreateSiteForm";
import BulkCreateSiteForm from "../models/BulkCreateSiteForm";
import CreateTeamSiteCard from "./CreateTeamSiteCard";
import CreateCommunicationSiteCard from "./CreateCommunicationSiteCard";
import { CommandBarButton } from "office-ui-fabric-react";
import SiteTypeSelection from "./SiteTypeSelection";
import * as React from "react";
import TableCell from "./TableCell";
import * as _ from "lodash";
import ApiService from "./ApiService";
import { IRootState } from "../store";
import { connect } from "react-redux";
import {MegaMenuOptions} from "./MegaMenuItemSelector";

interface BulkSiteCreatorProps {
    tenantId: string;
    schoolCode: string;
    bulkCreateSiteForm: BulkCreateSiteForm;
    megaMenuOptions: MegaMenuOptions;
    onFormChanged(bulkCreateSiteForm: BulkCreateSiteForm): void;
    disabled: boolean;
    apiService: ApiService;
}

interface BulkSiteCreatorState {
    selectedForm?: CreateSiteForm;
}

class BulkSiteCreator extends Component<BulkSiteCreatorProps, BulkSiteCreatorState>
{
    constructor(props: Readonly<BulkSiteCreatorProps>) {
        super(props);

        this.state = {
        };
    }

    public componentDidMount() {
        if (this.props.bulkCreateSiteForm?.forms?.length) {
            this.setState({
                selectedForm: this.props.bulkCreateSiteForm.forms[0]
            });
        }
    }

    componentDidUpdate(prevProps: Readonly<BulkSiteCreatorProps>, prevState: Readonly<BulkSiteCreatorState>, snapshot?: any): void {

        if (this.props.bulkCreateSiteForm !== prevProps.bulkCreateSiteForm) {
            if (this.props.bulkCreateSiteForm.forms.length === prevProps.bulkCreateSiteForm.forms.length) //assume bulk form has been saved if not changing due to add/removal of form
            {
                this.setState({
                    selectedForm: undefined
                });
            }
        }
    }

    private async addNewForm(siteType: SiteType) {

        let newForm;
        if (siteType === "communication") {
            // TODO: indicate to user that the site form is loading?
            newForm = await this.props.apiService.getBlankCommunicationSiteForm(this.props.tenantId, this.props.schoolCode);
        }
        else {
            newForm = new CreateSiteForm(siteType);
        }
        
        CreateSiteForm.setDefaultMegaMenuOptionIfExists(newForm,this.props.megaMenuOptions);

        const bulkCreateSiteForm = Object.assign({}, this.props.bulkCreateSiteForm, { forms: [newForm, ...this.props.bulkCreateSiteForm.forms] });

        this.setState({
            selectedForm: newForm
        });

        this.props.onFormChanged(bulkCreateSiteForm);
    }

    private removeForm(formToRemove: CreateSiteForm) {

        const forms = [...this.props.bulkCreateSiteForm.forms];
        const indexToRemove = forms.indexOf(formToRemove);
        forms.splice(indexToRemove, 1);

        const bulkCreateSiteForm = Object.assign({}, this.props.bulkCreateSiteForm, { forms: forms });

        let selectedForm = this.state.selectedForm;
        if (selectedForm === formToRemove) {
            selectedForm = forms.length > 0 ? forms[0] : undefined;
        }

        this.setState({
            selectedForm
        });

        this.props.onFormChanged(bulkCreateSiteForm);
    }

    private buildDeleteButton(form: CreateSiteForm): JSX.Element {

        return (
            <CommandBarButton
                disabled={this.props.disabled}
                iconProps={{ iconName: "Delete" }}
                text="Delete"
                onClick={() => this.removeForm(form)}
            />
        );
    }

    private buildAddButton(): JSX.Element {
        return (
            <CommandBarButton
                disabled={this.props.disabled}
                style={{ display: this.state.selectedForm ? "inherit" : "none" }}
                iconProps={{ iconName: "Add" }}
                text="Add"
                onClick={() => this.setState({
                    selectedForm: undefined
                })}
            />
        );
    }

    public render() {

        let content = null;

        if (this.state.selectedForm) {
            const SiteCardComponent = this.state.selectedForm.siteType === "teams" ? CreateTeamSiteCard : CreateCommunicationSiteCard;

            content = (
                <SiteCardComponent tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} disabled={this.props.disabled} form={this.state.selectedForm} megaMenuOptions={this.props.megaMenuOptions}>
                    {this.props.disabled ? null : this.buildDeleteButton(this.state.selectedForm)}
                </SiteCardComponent>
            )

        }
        else if (!this.props.disabled) {
            content = <SiteTypeSelection onCommunicationClicked={async () => await this.addNewForm("communication")} onTeamClicked={() => this.addNewForm("teams")} />;
        }

        const sortedForms = _.sortBy(this.props.bulkCreateSiteForm.forms, ["siteName", "siteType"]);

        return (
            <div className={"bulk-site-creator"}>

                <div className={"cdb-table card--thin flex-item--flex-1 cdb-table--enable-hover"} style={
                    {
                        display: this.props.bulkCreateSiteForm.forms.length > 0 ? "inherit" : "none"
                    }
                }>
                    <div className={"card__header"}>
                        <span className={"card__title"}>Sites</span>

                        {this.props.disabled ? null : this.buildAddButton()}
                    </div>

                    {sortedForms.map((form, i) => {
                        return (
                            <div key={i} className={`cdb-table__row ${form === this.state.selectedForm ? "cdb-table__row--selected" : ""}`}>
                                <TableCell className={"clickable"} flex={1} onClick={() => {
                                    this.setState({
                                        selectedForm: form
                                    })
                                }}>
                                    <span>{form.siteName ? form.siteName : `New ${_.capitalize(form.siteType)} Site`}</span>
                                    <span className={"cdb-table__extra-detail"}>{_.capitalize(form.siteType)} Site</span>
                                </TableCell>
                            </div>
                        );
                    })
                    }

                </div>

                <div className={"flex-row flex--flow-wrap flex--align-items-center flex-item--flex-9"}>
                    {content}
                </div>

            </div>
        );
    }
}

export default connect((state: IRootState, ownProps: { tenantId: string, schoolCode: string, bulkCreateSiteForm: BulkCreateSiteForm,megaMenuOptions: MegaMenuOptions, onFormChanged(bulkCreateSiteForm: BulkCreateSiteForm): void, disabled: boolean }): BulkSiteCreatorProps => {
    return {
        tenantId: ownProps.tenantId,
        schoolCode: ownProps.schoolCode,
        bulkCreateSiteForm: ownProps.bulkCreateSiteForm,
        megaMenuOptions: ownProps.megaMenuOptions,
        onFormChanged: ownProps.onFormChanged,
        disabled: ownProps.disabled,
        apiService: state.auth.apiService,
    }
})(BulkSiteCreator);
